// extracted by mini-css-extract-plugin
export default {"onboarding":"onboarding_onboarding__ewOz4"};